import agent from "../shared/agent";
import { action, makeAutoObservable } from "mobx"

class EntregadoresStore {
    inProgress = false;

    entregadores = [];

    error = "";

    setError(error) {
        this.error = error;
    }

    reset() {
        this.entregadores = [];
    }

    setEntregadores(entregadores) {
        this.entregadores = entregadores;
    }

    constructor() {
        makeAutoObservable(this);
    }

    cadastrarEntregador(nome, nomeResumido, celular, codExterno, cor) {
        this.inProgress = true;

        return agent.Entregadores.cadastrarEntregador(nome, nomeResumido, celular, codExterno, cor)
            .then((res) => {
                if (res.CodigoRetorno === 1) {
                    this.setError("");
                    // Return the response so we can access Registros in the component
                    return res;
                } else {
                    this.setError(res.Mensagem);
                    throw res;
                }
            })
            .finally(
                action(() => {
                    this.buscarEntregadores();
                    this.inProgress = false;
                })
            )
    }

    cadastrarUsuarioEntregador(entregadorId, nome, login, senha, ativo = 1) {
        this.inProgress = true;

        return agent.Entregadores.cadastrarUsuarioEntregador(entregadorId, nome, login, senha, ativo)
            .then((res) => {
                if (res.CodigoRetorno === 1) {
                    this.setError("");
                } else {
                    this.setError(res.Mensagem);
                    throw res;
                }
            })
            .finally(
                action(() => {
                    this.buscarEntregadores();
                    this.inProgress = false;
                })
            )
    }

    editarEntregador(id, nome, nomeResumido, celular, codExterno, cor) {
        this.inProgress = true;

        return agent.Entregadores.editarEntregador(id, nome, nomeResumido, celular, codExterno, cor)
            .then((res) => {
                if (res.CodigoRetorno === 1) {
                    this.setError("");
                } else {
                    this.setError(res.Mensagem);
                    throw res;
                }
            })
            .finally(
                action(() => {
                    this.buscarEntregadores();
                    this.inProgress = false;
                })
            )
    }

    mudarStatusEntregador(id, status) {
        this.inProgress = true;

        return agent.Entregadores.mudarStatusEntregador(id, status)
            .then((res) => {
                if (res.CodigoRetorno === 1) {
                    this.setError("");
                } else {
                    this.setError(res.Mensagem);
                    console.log(res.Mensagem);
                    throw res;
                }
            })
            .finally(
                action(() => {
                    this.buscarEntregadores();
                    this.inProgress = false;
                })
            )
    }

    excluirEntregador(id) {
        this.inProgress = true;

        return agent.Entregadores.excluirEntregador(id)
            .then((res) => {
                if (res.CodigoRetorno === 1) {
                    this.setError("");
                } else {
                    this.setError(res.Mensagem);
                    console.log(res.Mensagem);
                    throw res;
                }
            })
            .finally(
                action(() => {
                    this.buscarEntregadores();
                    this.inProgress = false;
                })
            )
    }

    buscarEntregadoresAtivos() {
        this.inProgress = true;
        let registros;
        return agent.Entregadores.listarEntregadores()
            .then((res) => {
                if (res.CodigoRetorno === 1) {
                    registros = res.Registros.filter(elem => elem.Ativo === 1);
                } else {
                    this.setError(res.Mensagem);
                    throw res;
                }
            })
            .finally(
                action(() => {
                    this.setEntregadores(registros);

                    this.inProgress = false;
                })
            );
    }

    buscarEntregadores() {
        this.inProgress = true;
        let registros;
        return agent.Entregadores.listarEntregadores()
            .then((res) => {
                if (res.CodigoRetorno === 1) {
                    registros = res.Registros;
                } else {
                    this.setError(res.Mensagem);
                    throw res;
                }
            })
            .finally(
                action(() => {
                    this.setEntregadores(registros);

                    this.inProgress = false;
                })
            );
    }
}

export default new EntregadoresStore();
